import React, { useEffect, useState, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Button } from 'react-bootstrap';
import Datepicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment';
import axios from 'axios';
import { render } from '@testing-library/react';
import { env } from './const';
import { headers } from '../utils/common';
import { Role } from '../utils/role';
import { getRole } from '../utils/common';
import * as axiosInstance from '../utils/axiosinstace';
import $ from 'jquery';
import 'select2';
import { useTranslation, Trans } from 'react-i18next';
const BatchMaster = (props) => {
  const { t } = useTranslation(['batch', 'common']);
    let show = props.showState;
    function handleChange() {
        props.onChange(false);
    }

    const { register, handleSubmit, watch, formState: { errors }, setValue, trigger, reset } = useForm({
        mode: 'onChange'
    });
    const [headersobj] = useState(headers());
    const [selectedDate, setSelectedDate] = useState(null);
    const [farmData, setFarmData] = useState([]);
    const [tempData, setTempData] = useState([]);
    const [showResults, setShowResults] = useState(false)
    const [resultMessage, setResultMessage] = useState({});
    const onSubmit = async (data, e) => {
        e.preventDefault();
        data.startDate = moment(selectedDate).format('YYYY-MM-DD');
        // alert(JSON.stringify(data))
        try {
            const response = await axiosInstance.addBatch(data)
            console.log(response.message);
            setShowResults(true);
            setResultMessage({
                error: false, message: response.message
            });

            e.target.reset();
        } catch (err) {
            console.log(err)
            setShowResults(true)
            setResultMessage({
                error: true, message: err.response.data.message
            });
            //console.log(err.response.data.message);
        }

    }
    const handleReset = () => {

        $('#selectFarmer').val('').trigger('change');
    };
    const [farmers, setFarmers] = useState([]);
    const listoffarms = useRef();
    const listofDevices = useRef();
    listoffarms.current = async (farmer) => {
        //alert("hi "+farmer);
        try {
            const response = await axiosInstance.getListofFarms(farmer)
            setFarmData(response.list)
        } catch (err) {
            console.log(err);
        }

    }
    listofDevices.current = async (farmer) => {
        try {
            const response = await axiosInstance.getListofAssignedDevices(farmer)
            setDeviceList(response.list)
        } catch (err) {
            console.log(err);
        }
    }
    const onFarmerChange = (e) => {
        //alert('hi')
        listoffarms.current(e.target.value);
        listofDevices.current(e.target.value);
    }
    const [deviceList, setDeviceList] = useState([]);
    const listoffarmers = useRef();
    listoffarmers.current = async () => {
        try {
            const response = await axiosInstance.getListofFarmers_admin()
            setFarmers(response.list)
        } catch (err) {
            console.log(err);
        }
    }
    const listoftemplates = useRef();
    listoftemplates.current = async () => {
        try {
            const response = await axiosInstance.getListofTemplates()
            setTempData(response.list)
        } catch (err) {
            console.log(err);
        }
    }
    const [integrators, setIntegrators] = useState([]);
    const listofIntegrators = useRef();
    listofIntegrators.current = async () => {
        try {
            const response = await axiosInstance.getIntegratorsList('dd')
            setIntegrators(response.list)
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        if (getRole() === Role.Admin) {
            listoffarmers.current();
        }
        if (getRole() === Role.Farmer) {
            listoffarms.current('farmer');
            listofDevices.current('farmer');
        }
        listoftemplates.current();
        listofIntegrators.current();
    }, [setResultMessage, headersobj]);
    useEffect(() => {


        $(document).ready(function () {
            $('#selectFarmer').select2();
            $('#selectFarmer').on('change', function (e) {

                setValue('farmer', e.target.value, { shouldValidate: true }); // Automatically triggers validation
                trigger('farmer'); // Manually trigger validation for 'selectFarm'

                onFarmerChange(e)
            });
        });

        // Cleanup function to remove the event listener
        return () => {
            $('#selectFarmer').off('change');
        };
    }, []);

    return (
        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('batch:add.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row'>
                            <div className='col-md-8'>
                                {showResults ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error} /> : null}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className="row">
                                    <div className='col-md-6'>
                                        <div className="form-group">
                                            <label htmlFor>{t('common:fields.batchName')}</label>
                                            <input type="text" className="form-control" placeholder={t('batch:add.enterBatchName')}
                                                name="farmName"
                                                {...register("batchName", {
                                                    required: t('forms:enter.batchName'),
                                                    minLength: { value: 3, message: t('common:validation.nameTooShort') },
                                                    maxLength: { value: 20, message: t('common:validation.nameTooLong') }
                                                })}
                                            />
                                            {errors.batchName && <span className="err-msg">{errors.batchName.message}</span>}
                                        </div>
                                    </div>

                                    {getRole() === Role.Admin ?
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>{t('common:select.farmer')}</label>
                                                <select class="form-control" name="farmer" id="selectFarmer"
                                                    {...register("farmer", {
                                                        required: t('forms:select.farmer'),

                                                    })}
                                                >
                                                    <option value="">{t('common:select.dashed')}</option>
                                                    {farmers.map(item => (
                                                        <option
                                                            key={item.userName}
                                                            value={item.userName}
                                                        >
                                                            {item.farmerName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.farmer && <span className="err-msg">{errors.farmer.message}</span>}
                                            </div>
                                        </div>
                                        : ""}
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="form-group">
                                            <label htmlFor>{t('common:select.barn')}</label>
                                            <select class="form-control" name="farmID"
                                                {...register('farmID', {
                                                    required: t('forms:select.farm')

                                                })}
                                            >
                                                <option value=''>{t('common:select.dashed')}</option>

                                                {farmData.map(item => (
                                                    <option
                                                        key={item.farmID}
                                                        value={item.farmID}
                                                    >
                                                        {item.farmName}
                                                    </option>
                                                ))}

                                            </select>
                                            {errors.farmID && <span className="err-msg">{errors.farmID.message}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor>{t('batch:add.assignDevice')}</label>
                                            <select class="form-control" name="imeiNumber"
                                                {...register('imeiNumber', {
                                                    required: t('forms:select.device')

                                                })}
                                            >
                                                <option value=''>{t('common:select.deviceDashed')}</option>

                                                {deviceList.map(item => (
                                                    <option
                                                        key={item.deviceID}
                                                        value={item.deviceID}
                                                    >
                                                        {item.deviceID}
                                                    </option>
                                                ))}

                                            </select>
                                            {errors.imeiNumber && <span className="err-msg">{errors.imeiNumber.message}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor>{t('batch:add.selectTemplate')}</label>
                                            <select class="form-control" name="templateID"
                                                {...register('templateID', {
                                                    required: t('forms:select.template')

                                                })}
                                            >
                                                <option value=''>{t('common:select.dashed')}</option>

                                                {tempData.map(item => (
                                                    <option
                                                        key={item.templateID}
                                                        value={item.templateID}
                                                    >
                                                        {item.templateName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.templateID && <span className="err-msg">{errors.templateID.message}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>{t('common:select.startDate')}</label>
                                            <Datepicker
                                                selected={selectedDate}
                                                onChange={(date) => setSelectedDate(date)}
                                                placeholderText="Start Date"
                                                //minDate={new Date()}
                                                dateFormat="dd-MMM-yyyy"
                                                name="startDate"
                                                className="form-control"
                                            >
                                            </Datepicker>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor>{t('common:entity.integrator')}</label>
                                            <select class="form-control" name="integrator"
                                                {...register('integrator', {
                                                    required: t('forms:select.integrator')
                                                })}
                                            >
                                                <option value=''>{t('common:select.integratorDashed')}</option>

                                                {integrators.map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {errors.integrator && <span className="err-msg">{errors.integrator.message}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-5'>
                                        <input type="submit" value="Save" class="btn btn-primary newBtn" />
                                        <input type="reset" onClick={handleReset} value="Reset" class="btn btn-secondary newBtn" />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6' style={{ paddingLeft: 20 }}>

                                <h5>{t('batch:add.instructions')}</h5>
                                <p>{t('batch:add.intro')}</p>
                                <ul className='ul-align'>
                                    <li><Trans i18nKey="batch:add.ruleUnique" components={{ b: <strong /> }} /></li>
                                    <li>{t('batch:add.ruleDuplicate')}</li>
                                    <li>
                                        <Trans
                                            i18nKey="batch:add.ruleSelectBarn"
                                            values={{ label: t('common:select.barn') }}
                                            components={{ b: <strong style={{ color: '#0654d1' }} /> }}
                                        />
                                    </li>
                                    <li>{t('batch:add.selectDeviceHint')} <strong style={{ color: '#0654d1' }}>{t('batch:add.assignDevice')}</strong>.
                                        <ul>
                                            <li><strong>{t('batch:add.note')}</strong>  {t('batch:add.noteDeviceFree')}
                                            </li>
                                        </ul>
                                    </li>
                                    <li>{t('batch:add.ruleTemplate')}</li>
                                    <li>{t('batch:add.ruleStartDate')}
                                        <ul>
                                            <li><strong>{t('batch:add.note')}</strong> {t('batch:add.noteDateRange')}
                                            </li>
                                        </ul>
                                    </li>
                                    <li>{t('batch:add.ruleAfterCreate')}</li>
                                </ul>
                            </div>
                        </div>

                    </form>
                </div>
            </div>

        </div>
        // <div>
        //     <Modal show={show} >
        //         <Modal.Header>
        //             <Modal.Title>
        //             <FontAwesomeIcon icon={faPlus} />
        //                 &nbsp; Add Batch</Modal.Title>
        //         </Modal.Header>
        //         <form onSubmit={handleSubmit(onSubmit)}>
        //             <Modal.Body>

        //                    <div className="row">
        //                        <div className="col-md-12">
        //                             <div className="form-group">
        //                                 <label htmlFor>{t('common:fields.batchName')}</label>
        //                                 <input type="text" className="form-control"  placeholder={t('batch:add.enterBatchName')}
        //                                 name="batchName" ref={register(
        //                                     { required: t('forms:requiredField.batchName'),
        //                                         minLength: {value: 3, message: t('common:validation.nameTooShort')},
        //                                         maxLength: {value: 20, message: t('common:validation.nameTooLong')}
        //                                     }
        //                                     )} />
        //                                 {errors.batchName && <span className="err-msg">{errors.batchName.message}</span>}
        //                             </div> 
        //                        </div>
        //                        {getRole()===Role.Admin ?
        //                        <div className="col-md-12">
        //                             <div className="form-group">
        //                                     <label>{t('common:select.farmer')}</label>
        //                                     <select class="form-control" name="farmer" onChange={onFarmerChange}
        //                                     ref={register ({
        //                                         required: t('forms:select.farmer')

        //                                     })}
        //                                     >
        //                                         <option value="">{t('common:select.dashed')}</option>
        //                                         {farmers.map(item => (
        //                                                 <option
        //                                                 key={item.userName}
        //                                                 value={item.userName}
        //                                                 >
        //                                                 {item.farmerName}
        //                                                 </option>
        //                                             ))}
        //                                     </select>
        //                                     {errors.farmer && <span className="err-msg">{errors.farmer.message}</span>}
        //                             </div> 
        //                        </div>
        //                         : ""}
        //                        <div className="col-md-12">
        //                             <div className="form-group">
        //                                 <label htmlFor>{t('common:select.barn')}</label>
        //                                 <select class="form-control" name="farmID" 
        //                                 ref={register ({
        //                                     required: t('forms:select.farm')

        //                                 })} 
        //                                 >
        //                                     <option value=''>{t('common:select.dashed')}</option>

        //                                        {farmData.map(item => (
        //                                         <option
        //                                           key={item.farmID}
        //                                           value={item.farmID}
        //                                         >
        //                                           {item.farmName}
        //                                         </option>
        //                                       ))}

        //                                 </select>
        //                             </div> 
        //                        </div>
        //                        <div className="col-md-12">
        //                             <div className="form-group">
        //                                 <label htmlFor>{t('batch:add.assignDevice')}</label>
        //                                 <select class="form-control" name="imeiNumber" 
        //                                 ref={register ({
        //                                     required: t('common:select.device')

        //                                 })} 
        //                                 >
        //                                     <option value=''>{t('common:select.dashed')}</option>

        //                                        {deviceList.map(item => (
        //                                         <option
        //                                           key={item.deviceID}
        //                                           value={item.deviceID}
        //                                         >
        //                                           {item.deviceID}
        //                                         </option>
        //                                       ))}

        //                                 </select>
        //                             </div> 
        //                        </div>
        //                        <div className="col-md-6">
        //                             <div className="form-group">
        //                                 <label htmlFor>{t('batch:add.selectTemplate')}</label>
        //                                 <select class="form-control" name="templateID" 
        //                                 ref={register ({
        //                                     required: t('forms:select.template')

        //                                 })} 
        //                                 >
        //                                     <option value=''>{t('common:select.dashed')}</option>

        //                                    {tempData.map(item => (
        //                                         <option
        //                                         key={item.templateID}
        //                                         value={item.templateID}
        //                                         >
        //                                         {item.templateName}
        //                                         </option>
        //                                     ))}
        //                                 </select>
        //                             </div> 
        //                        </div>

        //                        <div className="col-md-6">
        //                             <div className="form-group">
        //                                 <label>{t('common:select.startDate')}</label>
        //                                <Datepicker 
        //                                     selected={selectedDate} 
        //                                     onChange = {(date)=>setSelectedDate(date)}
        //                                     placeholderText = "Start Date" 
        //                                     minDate={new Date()}
        //                                     dateFormat="dd-MMM-yyyy"
        //                                     name="startDate"
        //                                     className = "form-control"
        //                                     >
        //                               </Datepicker>
        //                             </div> 
        //                        </div>
        //                    </div>
        //                    { showResults ? <Results key={Math.random()} message={resultMessage.message} error = {resultMessage.error}  /> : null }
        //             </Modal.Body>
        //         <Modal.Footer>
        //             <input type="submit"  disabled={!formState.isValid}  value="Save" class="btn btn-primary" />
        //             {/* <Button variant="primary" onClick= {handleChange}>{t('common:actions.close')}</Button> */}
        //             <Button variant="secondary" onClick= {handleChange}>{t('common:actions.close')}</Button>
        //         </Modal.Footer>
        //         </form>
        //     </Modal>
        // </div>

    );
}
const Results = (props) => {
    let error, classes;
    if (props.error === false) {
        error = 'Success';
        classes = 'alert alert-success alert-dismissible fade show'
    } else {
        error = 'Error!';
        classes = 'alert alert-danger alert-dismissible fade show'
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}
                <button type="button" class="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
}
export default BatchMaster;